import React from "react";
import AirPressure from "./AirPressure";
import AirTemp from "./AirTemp";
import Current from "./Current";
import Humidity from "./Humidity";
import PrecipAccum from "./PrecipAccum";
import PrecipInt from "./PrecipInt";
import PrecipType from "./PrecipType";
import Signal from "./Signal";
import SignalQuality from "./SignalQuality";
import Stage from "./Stage";
import Voltage from "./Voltage";
import WindDir from "./WindDir";
import WindSpeed from "./WindSpeed";

const Cards = {
  airPressureAbs:AirPressure,
  airTemp:AirTemp,
  current: Current,
  humidityRel:Humidity,
  precipAccum:PrecipAccum,
  precipIntensity:PrecipInt,
  precipType:PrecipType,
  signal:Signal,
  signalQuality:SignalQuality,
  stage: Stage,
  voltage: Voltage,
  windDir:WindDir,
  windSpeed:WindSpeed
};

export default (type,reading,site) => {
  if (typeof Cards[type] !== "undefined") {
    return React.createElement(Cards[type], {
      reading:reading,
      site:site
    });
  }
  return React.createElement(
    () => <div style={{width:300}}>The {type} card has not been created yet.</div>,
    {
      reading:reading,
      site:site
    }
  );
};